export default "__VITE_ASSET__Q0m1reXh__"